const InputTextView = require('./input_text_view')
const InputTextareaView = require('./input_textarea_view')
const InputCheckboxView = require('./input_checkbox_view')
const InputRadioView = require('./input_radio_view')
const InputRadiosetView = require('./input_radioset_view')
const InputSelectView = require('./input_select_view')
const InputButtonView = require('./input_button_view')
const InputButtonsetView = require('./input_buttonset_view')
const InputButtonFieldView = require('./input_buttonfield_view')

const InputViewTypes = {
    button: InputButtonView,
    buttonfield: InputButtonFieldView,
    buttonset: InputButtonsetView,
    checkbox: InputCheckboxView,
    email: InputTextView,
    file: InputTextView,
    hidden: InputTextView,
    number: InputTextView,
    password: InputTextView,
    radio: InputRadioView,
    radioset: InputRadiosetView,
    reset: InputButtonView,
    search: InputTextView,
    select: InputSelectView,
    submit: InputButtonView,
    tel: InputTextView,
    text: InputTextView,
    textarea: InputTextareaView,
    url: InputTextView,
}

module.exports = InputViewTypes
